import moment from 'moment';

class MaintenanceStatusFormatter {
	static maintenanceStatus(maintenanceService, activationDate) {
		let maintenanceStatus = 'Pending';

		if (
			!maintenanceService ||
			(Array.isArray(maintenanceService) && maintenanceService.length === 0)
		) {
			return maintenanceStatus;
		}

		const checkStatus = (service) => {
			// If not activated yet, it's pending
			if (!activationDate) {
				return 'Pending';
			}

			// Check if it's a trial maintenance plan (and activated)
			const maintenancePlan = service.maintenance_plan || service.plan;
			if (maintenancePlan) {
				const planName =
					maintenancePlan.synetoInternalName ||
					maintenancePlan.customerFacingName ||
					'';
				if (planName.toLowerCase().includes('trial')) {
					return 'Trial';
				}
			}

			// If no expiresOn date but is activated, determine based on plan type
			if (!service.expiresOn) {
				return 'Pending';
			}

			let expirationDate = moment(service.expiresOn);
			let maintenanceStatusFormatted = expirationDate
				.add(1, 'day')
				.format('YYYY-MM-DD');
			return moment().isBefore(maintenanceStatusFormatted)
				? 'Active'
				: 'Expired';
		};

		if (Array.isArray(maintenanceService)) {
			for (let service of maintenanceService) {
				maintenanceStatus = checkStatus(service);
				if (maintenanceStatus === 'Active' || maintenanceStatus === 'Trial') {
					break;
				}
			}
		} else {
			maintenanceStatus = checkStatus(maintenanceService);
		}

		return maintenanceStatus;
	}

	static setExpiresOnBadge(status) {
		switch (status) {
			case 'Active':
				return 'secondary';
			case 'Expired':
				return 'danger';
		}
	}

	static setStyle(status) {
		switch (status) {
			case 'Active':
				return 'success';
			case 'Trial':
				return 'info';
			case 'Pending':
				return 'warning';
			case 'Expired':
				return 'danger';
		}
	}

	static setStyleAddon(status) {
		// The server sends a license's status in lower case
		switch (typeof status === 'string' ? status.toLowerCase() : status) {
			case 'active':
				return 'success';
			case 'terminated':
				return 'danger';
		}
	}

	static setTooltipInformation(expiresOn) {
		let tooltipInformation = '';

		if (!expiresOn) {
			tooltipInformation = 'Pending. Product not activated yet!';
		} else {
			let expiresOnFormatted = moment(expiresOn).format('YYYY-MM-DD');
			if (moment().isBefore(expiresOnFormatted)) {
				tooltipInformation = `Expires on ${expiresOnFormatted}`;
			} else {
				tooltipInformation = `Expired on ${expiresOnFormatted}`;
			}
		}

		return tooltipInformation;
	}

	static showTooltipDate(expiresOn) {
		if (!expiresOn) {
			return 'Pending. Product not activated yet!';
		}

		if (moment().isBefore(moment(expiresOn, 'DD/MM/YYYY'))) {
			return `Expires on ${expiresOn}`;
		} else {
			return `Expired on ${expiresOn}`;
		}
	}
}

export default MaintenanceStatusFormatter;
